<template>
    <div>
      <ChartWrapper
        :data="data"
        :width="width"
        :height="height"
        :primaryKey="primaryKey"
        :dimensionKey="dimensionKey"
        :chartDefaults="chartDefaults"
      >
        <template #x-axis="props">
          <XAxis
            v-bind="props"
            :textColor="chartColor"
            :lineColor="chartColor"
          />
        </template>
        <template #y-axis="props">
          <YAxis
            v-bind="props"
            :isInPercentages="true"
            intervalStyle="stroke-dasharray: 4 2; stroke: #C1CCD4"
            :textColor="chartColor"
          />
        </template>
        <template #bars="props">
          <SingleBar
            v-bind="props"
            :hasTransitions="true"
            :primaryColor="barColor"
            :barWidth="barWidth"
            :barPadding="barPadding"
          />
        </template>
      </ChartWrapper>
    </div>
</template>

<script>
import ChartWrapper from '../../Common/Charting/Shared/Graph/ChartWrapper.vue';
import XAxis from '../../Common/Charting/Shared/Graph/Axes/XAxis.vue';
import YAxis from '../../Common/Charting/Shared/Graph/Axes/YAxis.vue';
import SingleBar from '../../Common/Charting/Shared/Graph/Bars/SingleBar.vue';

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    height: {
      type: Number,
      default: 275,
    },
    width: {
      type: Number,
      default: 600,
    },
    primaryKey: {
      type: String,
      required: true,
    },
    dimensionKey: {
      type: String,
      required: true,
    },
  },
  components: {
    ChartWrapper,
    XAxis,
    YAxis,
    SingleBar,
  },
  data() {
    return {
      barWidth: 24,
      barPadding: 0,
      barColor: '#4369F4',
      chartColor: '#778699',
    };
  },
  computed: {
    chartDefaults() {
      return {
        dataWidth: this.barWidth,
        xLabelPadding: 16,
        yLabelPadding: 8,
        yLabelWidth: 30,
        fontSize: 12,
        margin: {
          top: 5,
          right: 0,
          bottom: 0,
          left: 10,
        },
      };
    },
  },
};
</script>

